import { render, staticRenderFns } from "./ItemListMock.vue?vue&type=template&id=3d822698&"
import script from "./ItemListMock.vue?vue&type=script&lang=js&"
export * from "./ItemListMock.vue?vue&type=script&lang=js&"
import style0 from "./ItemListMock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports